// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3rjnO","title":"ClientCherryInfo_title__16jtr","itemText":"ClientCherryInfo_itemText__27uba"};